import React, { useEffect, useState, useRef } from "react";
import moment from "moment";
import API from "../Services/Occasion";
import CenterModal from "../Components/CenterSelectorModal";
import LocationList from "../Components/Location";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const OccasionList = () => {

    const [occasionData, setOccasionData] = useState([]);
    const [name, setName] = useState("");
    const [date, setDate] = useState("");
    const [selectedCenter, setSelectedCenter] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage] = useState(10);
    const [totalPages, setTotalPages] = useState(1);

    const [apiError, setApiError] = useState("");
    const [locationId, setLocationId] = useState("");
    const [formError, setFormError] = useState({});
    const [createdAt, setCreatedAt] = useState("");
    const [centerName, setCenterName] = useState("")
    const [status, setStatus] = useState("");
    const [id, setId] = useState("");
    const isFetched = useRef(false);

    const getOccasion = async () => {
        try {
            const centerlist = Array.isArray(selectedCenter)
                ? selectedCenter.join(",")
                : selectedCenter;

            const payload = { id: null, page: currentPage, location_id: centerlist || null };
          //  console.log('ppaayy', payload);
            const response = await API.getOccasion(payload);
            setOccasionData(response?.data?.response || []);
            const total = response?.data?.totalCount?.totalRecords || 0;
            setTotalPages(Math.ceil(total / perPage));

        } catch (err) {
            if (err?.response?.status === 403) {
                window.location.replace("/Login");
            }
            // setApiError("Something went wrong while fetching occasions");
            console.log(err);
        }
    };
    // useEffect(() => {
    //     getOccasion();
    // }, [currentPage]);

      useEffect(() => {
      if (selectedCenter.length > 0) {
        getOccasion(currentPage);
      }
    }, [currentPage, selectedCenter]);
    

    const handleGetData = async (id) => {
        try {
            const response = await API.getOccasion({ id,location_id:null });
            const fetchedData = response?.data?.response[0];
            // console.log('dddd',fetchedData);
            if (!fetchedData) return;
            setName(fetchedData.ocation_name);
            setDate(fetchedData.date);
            // setSelectedCenter([fetchedData.location_id]);
            setLocationId(fetchedData?.location_id)
            setCenterName(fetchedData?.center_name)
            setStatus(fetchedData?.is_active)
            setCreatedAt(fetchedData?.createdAt)
            setId(fetchedData?.id)
        } catch (err) {

            console.log(err);
        }
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const getPageNumbers = () => {
        const maxVisible = 10;
        const pageNumbers = [];

        if (totalPages <= maxVisible) {
            for (let i = 1; i <= totalPages; i++) pageNumbers.push(i);
        } else {
            const left = Math.max(1, currentPage - 3);
            const right = Math.min(totalPages, currentPage + 3);

            if (left > 2) pageNumbers.push(1, '...');
            for (let i = left; i <= right; i++) pageNumbers.push(i);
            if (right < totalPages - 1) pageNumbers.push('...', totalPages);
        }
        return pageNumbers;
    };

    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;

        setFormError((prev) => ({ ...prev, [fieldName]: "" }));

        if (fieldName === "name") setName(value);
        if (fieldName === "date") setDate(value);
    };

    const validateFields = () => {
        const errors = {};

        if (!name.trim()) errors.name = "Occasion name is required";
        if (!date.trim()) errors.date = "Date is required";
        if (!locationId || locationId.length === 0) {
            errors.locationId = "Please select a center";
        }
        setFormError(errors);

        return Object.keys(errors).length === 0;
    };
    const changeStatus = async (id, currentStatus) => {
        try {
            const response = await API.updateStatus(id);

            if (response.status === 200) {

                const newStatus = currentStatus === 1 || currentStatus === true ? 0 : 1;
                setOccasionData((prevData) =>
                    prevData.map((item) =>
                        item.id === id ? { ...item, is_active: newStatus } : item
                    )
                );
                getOccasion();
                toast.success(response.data.message);
            } else {
                toast.error("Failed to update the status.");
            }

        } catch (error) {

            if (error?.response?.status === 403) {
                window.location.replace("/Login");
                return;
            }

            toast.error("Error updating status. Please try again.");
            console.error("Error toggling status:", error);
        }
    };


    const handleUpdate = async () => {
        if (!validateFields()) return;
        try {
            const payload = {
                id: id,
                date: date,
                location_id: parseInt(locationId),
                name: name
            };

            const response = await API.updateOccasion(payload);
            if (response?.status === 200 || response?.status === 201) {
                //console.log('response?.data?.message', response?.data?.message)
                toast.success(response?.data?.message || "Occasion updated successfully!");
                setTimeout(() => window.location.reload(), 2000);
            }
            else {
                toast.error(response?.data?.message || "Failed to update occasion!");
            }

        } catch (error) {

            if (error?.response?.status === 403) {
                window.location.replace("/Login");
                return;
            }

            toast.error(error?.response?.data?.message || error.message);
        }
    };

    const handleSelectedCenter = (selectedData) => {
        setSelectedCenter(selectedData);
    };
    const handleSearch = () => {
        setCurrentPage(1);
        getOccasion(1);
    };


    return (
        <div>
            <div className="col-lg-12 grid-margin stretch-card">

                <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h4 className="card-title mb-0">Added Occasion</h4>
                    </div>
                    <div className="card-body">
                        <div className="row mb-2">
                            <div className="col-md-5">
                                <CenterModal onSelectCenter={handleSelectedCenter} />
                            </div>
                            <div className="col-md-3 d-flex align-items-end">
                                <button
                                    onClick={handleSearch}
                                    className="btn btn-success w-100"
                                    type="button"
                                >
                                    Search
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        {apiError && <p className="text-danger">{apiError}</p>}

                        <div className="table-responsive">
                            <table className="table table-bordered text-center">
                                <thead>
                                    <tr>
                                        <th>SrNo</th>
                                        <th>Action</th>
                                        <th>Date</th>
                                        <th>Center Name</th>
                                        <th>Name</th>
                                        <th>Status</th>
                                        <th>Created-Date</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {occasionData.length > 0 ? (
                                        occasionData.map((item, index) => (
                                            <tr
                                                key={item.id}
                                                data-active={item?.is_active ? "true" : "false"}
                                            >
                                                <td>{(currentPage - 1) * perPage + index + 1}</td>

                                                <td>
                                                    <div className="navbar-menu-wrapper d-flex align-items-stretch" style={{ justifyContent: 'center', alignItems: "center", display: "flex" }}>
                                                        <ul className="navbar-nav navbar-nav-right">
                                                            <li className="nav-item nav-profile1">
                                                                <span className="nav-link dropdown-toggle1 text-center" id="actionDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                                                                    <div className="nav-profile-text1">
                                                                        <p className="mb-1 text-black">
                                                                        </p>
                                                                    </div>
                                                                </span>
                                                                <span className="nav-link mdi mdi-menu" style={{ width: "50px", fontSize: "30px", color: "black", }} id="profileDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false"></span>
                                                                <div className="dropdown-menu navbar-dropdown" aria-labelledby="actionDropdown">
                                                                    <a className="dropdown-item">
                                                                        <button onClick={() => handleGetData(item?.id)} className="btn btn-success btn-sm" type="button" data-bs-toggle="modal" data-bs-target="#myModalView">
                                                                            View
                                                                        </button>
                                                                    </a>
                                                                    <div className="dropdown-divider"></div>
                                                                    <a className="dropdown-item">
                                                                        <button onClick={() => handleGetData(item?.id)}
                                                                            className="btn btn-primary btn-sm" type="button"
                                                                            data-bs-toggle="modal" data-bs-target="#myModalEdit"
                                                                        >
                                                                            Edit
                                                                        </button>
                                                                    </a>
                                                                    <div className="dropdown-divider"></div>
                                                                    <a className="dropdown-item">

                                                                        <button
                                                                            className={`btn btn-sm ${item?.is_active ? "btn-secondary" : "btn-info"}`}
                                                                            onClick={() => changeStatus(item?.id, item?.is_active)}
                                                                        >
                                                                            {item?.is_active ? "De-Activate" : "Activate"}
                                                                        </button>

                                                                    </a>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </td>

                                                <td>{item.date}</td>
                                                <td>{item.center_name}</td>
                                                <td>{item.ocation_name}</td>
                                                <td>{item.is_active ? "Active" : "De-Activated"}</td>
                                                <td>{moment(item.createdAt).format("DD-MM-YYYY")}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="7">No Records Found</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>

                            <nav aria-label="Page navigation example">
                                <ul className="pagination justify-content-center mt-4">

                                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage - 1)}
                                        >
                                            Previous
                                        </button>
                                    </li>

                                    {getPageNumbers().map((page, index) => (
                                        <li key={index}
                                            className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""}`}>
                                            {page === "..." ? (
                                                <span className="page-link">...</span>
                                            ) : (
                                                <button className="page-link" onClick={() => handlePageChange(page)}>
                                                    {page}
                                                </button>
                                            )}
                                        </li>
                                    ))}

                                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage + 1)}
                                        >
                                            Next
                                        </button>
                                    </li>
                                </ul>
                            </nav>

                        </div>
                    </div>

                </div>
                <div className="modal" id="myModalEdit">
                    <div className="modal-dialog modal-lg" style={{ width: "750px" }}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Edit Occasion</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">

                                <div className="row">

                                    <div className="col-md-6">
                                        <label>Date <span className="text-danger">*</span></label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={date}
                                            onChange={(e) => handleFieldChange(e, "date")}
                                            min={new Date().toISOString().split("T")[0]}
                                        />
                                        {formError.date && <small className="text-danger">{formError.date}</small>}
                                    </div>

                                    <div className="col-md-6">
                                        <LocationList
                                            selectedLocation={locationId}
                                            label="Center Name"
                                            isRequired={true}
                                            disabled={false}
                                            setSelectedLocation={(location) => setLocationId(location)}
                                        />
                                        {formError.locationId && <small className="text-danger">{formError.locationId}</small>}
                                    </div>

                                    <div className="col-md-6 mt-2">
                                        <label>Occasion Name <span className="text-danger">*</span></label>
                                        <input
                                            className="form-control"
                                            placeholder="Occasion Name"
                                            value={name}
                                            onChange={(e) => handleFieldChange(e, "name")}
                                        />
                                        {formError.name && <small className="text-danger">{formError.name}</small>}
                                    </div>

                                </div>
                                <div className="modal-footer">
                                    <button className="btn btn-primary" type="button" onClick={handleUpdate} >Update</button>
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal" id="myModalView">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">View Occasion</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">
                                <table className="table table-bordered border-secondary">
                                    <thead>
                                        <tr>

                                            <th>Date</th>
                                            <th>Center Name</th>
                                            <th>Name</th>


                                        </tr>
                                        <tr>
                                            <td>{date}</td>
                                            <td>{centerName}</td>
                                            <td>{name}</td>


                                        </tr>

                                        <tr>
                                            <th>Status</th>
                                            <th>Created Date</th>

                                        </tr>
                                        <tr>
                                            <td>{status ? "Active" : "De-Activated"}</td>
                                            <td colSpan={2}>{moment(createdAt).format("DD-MM-YYYY")}
                                            </td>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OccasionList;
